import { render } from "./CircleStages.vue?vue&type=template&id=1a834a3e&scoped=true"
import script from "./CircleStages.vue?vue&type=script&lang=js"
export * from "./CircleStages.vue?vue&type=script&lang=js"

import "./CircleStages.vue?vue&type=style&index=0&id=1a834a3e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a834a3e"]])

export default __exports__